import history from 'redux/history';

declare global {
   interface Window {
      pushLocation: (location: string) => void;
   }
}

export const useHistoryChanger = () => {
   window.pushLocation = history.push;
};
